import {PersonalPlanHomePage} from 'src/features/personal-plan-home/personal-plan-home-page';
import {withRouteGuard} from 'src/lib/withRouteGuard';

import {PAGE_KEYS} from '../constants';
import {personalPlanHomePageDataHandler} from './data-handler';

export const getServerSideProps = withRouteGuard(
    PAGE_KEYS.PERSONAL_PLAN_LOGGED_IN_HOME,
    personalPlanHomePageDataHandler,
);

export default PersonalPlanHomePage;
